// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-sidenav {
  width: 15%;
  background-color: var(--theme-main-background-color, #055C8D);
  color: white;
  min-width: 160px;
}

mat-sidenav-content {
  overflow-y: hidden;
}

.user-area {
  display: flex;
  bottom: 1%;
  width: 100%;
}

a span {
  vertical-align: middle;
}

.menu-items {
  height: 100% !important;
}

.icon-text {
  margin-top: 5px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
